import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { Subscricao } from "src/app/model/subscricao.model";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TipoCotistaEnum } from "src/app/model/tipo-cotista-enum";

export interface  NovaSubscricaoDTO {
  numeroAporte: number;
  data: Date;
  valor: number;
  categoria: string;
}

export interface NovasSubscricoesDTO {
  idCotista: number;
  tipoCotista: TipoCotistaEnum;
  subscricoes: NovaSubscricaoDTO[];
}

export interface SubscricaoDto {
  id?: number;
  data: Date;
  valor: number;
  categoria: string;
}

@Injectable({
    providedIn: 'root'
})
export class SubscricaoService extends FgiBackEndService<Subscricao>{

    getNewEntity(): Subscricao {
        const model = new Subscricao();
        model.dataRegistro = new Date();
        return model;
    }

    protected getResourceURL(): string {
        return 'front/subscricao';
    }

    getSubscricoes(params?: any): any{
        return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<Array<Subscricao>>;
    }

    getCategorias(): any{
        return this.http.get(`${this.BASE_URL}/categorias`).pipe(
            catchError((e) => this.handleError(e))) as Observable<[]>;
    }

    getSubscricoesPorCotistaEModalidade(idCotista, tipoCotista) {
      const options = blockUi();
      return this.http.get(`${this.BASE_URL}/cotista/${idCotista}/${tipoCotista}`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<Subscricao>>;
    }

    salvar(dadosNovasSubscricoes: NovasSubscricoesDTO) {
      const options = blockUi();
      return this.http.post(`${this.BASE_URL}/cotista`, dadosNovasSubscricoes, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
    }

    editar(dadosEdicaoSubscricao: SubscricaoDto) {
      const options = blockUi();
      return this.http.post(`${this.BASE_URL}/editar`, dadosEdicaoSubscricao, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
    }

    remover(idSubscricao: number) {
      const options = blockUi();
      return this.http.post(`${this.BASE_URL}/${idSubscricao}`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
    }
}
